export default {
  lookups: {},
  lookupsZeus: {}, // populated via action
  groups: [],
  timeZones: [],
  insuranceCompanies: [],
  vehicleMakes: [],
  odometerunits: [],
  damagepositions: [],
  staticDataLoaded: false
}
